
;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.filters')
    .filter('label', LabelFilter)
  LabelFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function LabelFilter (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    const corresp = {
      'title': 'titre',
      'ref': 'la référence',
      'priority': 'la priorité',
      'dueDate': `l'échéance`,
      'files': 'pièces jointes',
      'tags': 'mots-clés',
      'status': `l'état`,
      'isDeleted': 'supprimée',
      'isArchived': 'archivée',
      'number': 'numéro',
      'description': 'description',
      'currentRev': 'révision courante',
      'rev': {
        sub: '%2 à la révision %1',
        default: 'révisions'
      },
      'validatedBy': 'validations',
      'validators': 'valideurs',
      'subNumber': 'numéro',
      'referers': 'référents',
      'lines': {
        sub: '%2 de la ligne %1',
        default: 'lignes'
      },
      'reference': 'la référence',
      'price': 'prix',
      'discount': 'la remise',
      'globalDiscount': 'la remise globale',
      'payments': 'paiements'
    }

    function findCorresp (text, type) {
      if (corresp[text]) {
        if (typeof corresp[text] === 'string') return corresp[text]
        if (typeof corresp[text] === 'object') {
          if (corresp[text][type]) return corresp[text][type]
          if (corresp[text]['default']) return corresp[text]['default']
        }
      }
    }

    /**
     * Return label for intervention and order properties
     *
     */
    return function findLabelFilter (text, type) {
      if (findCorresp(text, type)) return findCorresp(text, type)
      var path = text
      if (path.includes('customFields.')) {
        return 'champs personnalisé ' + text.replace('customFields.', '')
      }
      // Splits "lines[0].reference" into ["lines", "0", "reference"]
      path = text.split(/\.|\[(\d+)\]\.?/)
      var t = findCorresp(path[0], 'sub')
      if (!t) {
        return text
      }
      return t.replace(/%(\d+)/g, function (match, number) {
        if (!path[number]) return ''
        return findLabelFilter(path[number], type) || path[number]
      })
    }
  }
})(window.angular, window._)
